module.exports = __webpack_public_path__ + "img/ylmf.3d59de55.jpg";